import React, { useEffect, useState } from 'react';
import { SIG_CMP_GROUP_SET, GetRawWaveformsComparisonGroupList, GroupListType } from '../../../function/GroupDataModel';
import GroupSelectGrid, { SelectGroupType } from '../../organisms/Pages/GroupSelectGrid';
import { useHistory } from 'react-router-dom';
import Paper from '@material-ui/core/Paper';
import { makeStyles, createStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(
  createStyles({
    paper: {
      padding: '10px',
      background: '#FFFFEE',
    },
    tableContainer: { maxHeight: 'calc(100vh - 210px)' },
  })
);

const RawWaveformComparisonGroupSelectPage: React.FC = () => {
  const history = useHistory();
  const classes = useStyles();

  const [groupDt, setGroupDt] = useState<SIG_CMP_GROUP_SET[]>([]);
  const [groupList, setGroupList] = useState<SelectGroupType[]>([]);

  useEffect(() => {
    GetRawWaveformsComparisonGroupList().then((ret) => {
      var fillter = ret.SIG_CMP_GROUP_SETs.filter((item) => item.DSP_FLG == 1);
      setGroupDt(fillter);
    });
  }, []);

  useEffect(() => {
    var lists: SelectGroupType[] = [];
    for (var i in groupDt) {
      lists.push({ index: Number(i) + 1, groupName: groupDt[i].GROUP_NAME, groupNo: groupDt[i].GROUP_NO });
    }
    setGroupList(lists);
    console.debug(lists);
  }, [groupDt]);

  const groupSelect = (selectdata: SelectGroupType) => {
    var target = groupDt.find((row) => row.GROUP_NO == selectdata.groupNo);
    history.push({
      pathname: '/RawWaveformComparisonPage',
      state: target,
    });
  };

  return <GroupSelectGrid groupList={groupList} onSelect={groupSelect} tableContainerStyle={classes.tableContainer} />;
};

export default RawWaveformComparisonGroupSelectPage;
